import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { CompaniesModule } from '../companies/companies.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { HomeComponent } from './home/home.component';
import { HomeStoresComponent } from './home-stores/home-stores.component';
import { HomeOrdersComponent } from './home-orders/home-orders.component';
import { HomeBuyersComponent } from './home-buyers/home-buyers.component';
import { HomeEvaluationCompaniesComponent } from './home-evaluation-companies/home-evaluation-companies.component';
import { HomeSignatureCompaniesComponent } from './home-signature-companies/home-signature-companies.component';
import { HomeAcceptanceCompaniesComponent } from './home-acceptance-companies/home-acceptance-companies.component';
import { HomeHeaderComponent } from './home-header/home-header.component';
import { HomeOrdersItemComponent } from './home-orders-item/home-orders-item.component';
import { HomeStoresItemComponent } from './home-stores-item/home-stores-item.component';
import { HomeBuyersItemComponent } from './home-buyers-item/home-buyers-item.component';
import { HomeCompaniesItemComponent } from './home-companies-item/home-companies-item.component';
import { HomeActionsComponent } from './home-actions/home-actions.component';

@NgModule({
  declarations: [
    HomeComponent,
    HomeStoresComponent,
    HomeOrdersComponent,
    HomeBuyersComponent,
    HomeEvaluationCompaniesComponent,
    HomeSignatureCompaniesComponent,
    HomeAcceptanceCompaniesComponent,
    HomeHeaderComponent,
    HomeOrdersItemComponent,
    HomeStoresItemComponent,
    HomeBuyersItemComponent,
    HomeCompaniesItemComponent,
    HomeActionsComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    CompaniesModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class HomeModule {}
